var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabItem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "url(#paint0_linear_1071_57)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 24.5L23.5556 27.5L29.3333 21.5M25 11L27.759 13.8072L31.5 12.8087L32.5377 16.6723L36.2583 17.75L35.2967 21.6349L38 24.5L35.2967 27.3651L36.2583 31.25L32.5377 32.3276L31.5 36.1913L27.759 35.1927L25 38L22.241 35.1927L18.5 36.1913L17.4622 32.3276L13.7417 31.25L14.7032 27.3651L12 24.5L14.7032 21.6349L13.7417 17.75L17.4622 16.6723L18.5 12.8087L22.241 13.8072L25 11Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1071_57",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FCFFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabItem3);
export default __webpack_public_path__ + "static/media/tab_item-3.d6359b2ac00c59ae8422ed2e8d73da00.svg";
export { ForwardRef as ReactComponent };